import React, { FC } from "react";
import { ReportPage, ReportTreasurySearchPanel } from "../../../components";
import { PageEnum, TreasuryReportSearchParamsModel } from "../../../models";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import { searchReportOutMoney } from "../../../serviceBroker/treasuryReportApiServiceBroker";
import { subDays } from "date-fns";

export const ReportOutMoneyPage: FC = () => {
  const today = new Date();
  const sevenDaysAgo = subDays(today, 7);

  const initialState: TreasuryReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
    toDate: new Date(),
    fromDate: sevenDaysAgo,
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={searchReportOutMoney}
      excludeFields={["currencyId"]}
      searchHeader={getPageNameByPageId(PageEnum.ReportOutMoney)}
      SearchPanel={ReportTreasurySearchPanel}
      formId={PageEnum.ReportOutMoney}
    />
  );
};
